import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import {
  ShoppingCart, List, SignOut, User, X,
} from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { useState } from "react";

const roleLabels = { student: "Alumno", company: "Empresa", instructor: "Relator", admin: "Administrador" };

export default function Navbar() {
  const { user, logout } = useAuth();
  const cartCtx = useCart();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/catalogo", label: "Catálogo" },
    { to: "/verificar", label: "Verificar certificado" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="navbar-logo">
          <Logo className="h-9" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label}`}
              className="text-sm font-medium text-muted-foreground hover:text-primary transition-transform hover:-translate-y-[1px]">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {user && user.role === "student" && (
            <Link to="/carrito" className="relative p-2" data-testid="navbar-cart">
              <ShoppingCart size={22} className="text-foreground" />
              {cartCtx?.count > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-accent text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-bold">
                  {cartCtx.count}
                </span>
              )}
            </Link>
          )}

          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="gap-2" data-testid="navbar-user-menu">
                  <User size={16} /> <span className="hidden sm:inline max-w-[120px] truncate">{user.name}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-52 bg-white">
                <DropdownMenuLabel>
                  <div className="font-semibold">{user.name}</div>
                  <div className="text-xs text-muted-foreground">{roleLabels[user.role]}</div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate("/dashboard")} data-testid="menu-dashboard">
                  Mi panel
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => { logout(); navigate("/"); }} data-testid="menu-logout">
                  <SignOut size={16} className="mr-2" /> Cerrar sesión
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <div className="hidden md:flex items-center gap-2">
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="navbar-login">
                Ingresar
              </Button>
              <Button size="sm" onClick={() => navigate("/register")} data-testid="navbar-register"
                className="bg-primary hover:bg-blue-600 text-white">
                Crear cuenta
              </Button>
            </div>
          )}
          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="navbar-mobile-toggle">
            {open ? <X size={22} /> : <List size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-white px-4 py-3 space-y-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block py-2 text-sm font-medium">{l.label}</Link>
          ))}
          {!user && (
            <div className="flex gap-2 pt-2">
              <Button variant="outline" className="flex-1" onClick={() => navigate("/login")}>Ingresar</Button>
              <Button className="flex-1 bg-primary text-white" onClick={() => navigate("/register")}>Crear cuenta</Button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
